import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  filter: [],
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    filterChange: (state, action) => {
      state.filter.push(action.payload);
    },
    filterRemove: (state, action) => {
      state.filter = state.filter.filter((f) => f !== action.payload);
    },
    searchHandle: (state, action) => {
      state.search = action.payload;
    },
  },
});

export const { filterChange, searchHandle, filterRemove } = filterSlice.actions;
export default filterSlice.reducer;
